import { SVGProps } from "react";
const ConversationsSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={22}
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      stroke="#2A2D31"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9 13.5H13.5C14.7428 13.5 15.75 12.4928 15.75 11.25V5.25C15.75 4.00725 14.7428 3 13.5 3H4.5C3.25725 3 2.25 4.00725 2.25 5.25V11.25C2.25 12.4928 3.25725 13.5 4.5 13.5H5.625V15.75L9 13.5Z"
    />
  </svg>
);
export default ConversationsSvg;
